import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { TabsContent } from '@/components/ui/Tabs.tsx';
import TabScreen from '@/components/ui/TabScreen.tsx';
import {
  INSURANCES_TABS,
  insurancesRoute,
  InsurancesTab,
} from '@/features/dashboard/insurances/routes/insurancesRoute.ts';
import InsuredParticipantsTable from '@/features/dashboard/insurances/components/InsuredParticipantsTable.tsx';
import ClientsWithInsuranceTable from '@/features/dashboard/insurances/components/ClientsWithInsuranceTable.tsx';
import InsuranceTypesTable from '@/features/dashboard/insurances/components/InsuranceTypesTable.tsx';
import CreateInsuranceModal from '@/features/dashboard/insurances/components/CreateInsuranceModal.tsx';

const InsurancesPage = () => {
  const { tab } = insurancesRoute.useSearch();
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <>
      <TabScreen
        tabs={INSURANCES_TABS}
        value={tab}
        onChange={(value) =>
          navigate({ to: '/app/insurances', search: { tab: value } })
        }
        title="Ubezpieczenia"
        menuDescription="Polisy uczestników i oferta ubezpieczeń. Wybierz sekcję."
        primaryAction={
          tab === InsurancesTab.TYPES
            ? {
                label: 'Dodaj ubezpieczenie',
                icon: Plus,
                onClick: () => setIsCreateModalOpen(true),
              }
            : undefined
        }
      >
        <TabsContent value={InsurancesTab.PARTICIPANTS}>
          <InsuredParticipantsTable />
        </TabsContent>

        <TabsContent value={InsurancesTab.CLIENTS}>
          <ClientsWithInsuranceTable />
        </TabsContent>

        <TabsContent value={InsurancesTab.TYPES}>
          <InsuranceTypesTable />
        </TabsContent>
      </TabScreen>

      {isCreateModalOpen && (
        <CreateInsuranceModal onClose={() => setIsCreateModalOpen(false)} />
      )}
    </>
  );
};

export default InsurancesPage;
